import styles from './Home.module.css';
import heroImage from './hero-image.png';
import aboutImage from './about-image.jpg';
import ServiceCard from '../../components/ServiceCard/ServiceCard.jsx';
import Gallery from '../../components/Gallery/Gallery.jsx';
import { ReactComponent as speechBubbleIcon} from './speech-bubble-icon.svg';
import {ReactComponent as surgeryToolsIcon} from './surgery-tools-icon.svg';
import { ReactComponent as dyslexiaIcon} from './dyslexia-icon.svg';
import roomPhoto1 from '../../assets/room-photo1.jpg';
import roomPhoto2 from '../../assets/room-photo2.jpg';
import roomPhoto3 from '../../assets/room-photo3.jpg';
import roomPhoto4 from '../../assets/room-photo4.jpg';


export default function Home() {
  const galleryImages = [
    { src: roomPhoto1, alt: "Therapy room view 1" },
    { src: roomPhoto2, alt: "Therapy room view 2" },
    { src: roomPhoto3, alt: "Therapy room view 3" },
    { src: roomPhoto4, alt: "Therapy room view 4" }
  ];

  return (
    <main>
        <section className={styles.hero}>
            <div className={styles.heroContent}>
                <h1 className={styles.heroHeader}>SPECJALISTYCZNA TERAPIA DLA DZIECI MŁODZIEŻY I DOROSŁYCH</h1>
                <p className={styles.heroDescription}>Empatia, cierpliwość, indywidualne podejście, terapia poprzez zabawę w domowej atmosferze.</p>
            </div>
            <div className={styles.heroImageWrapper}>
                <img src={heroImage} alt="" />
            </div>
        </section>
        <section className={styles.services}>
        <h2>TERAPIA, WSPARCIE</h2>
        <div className={styles.serviceWrapper}>
        <div className={styles.servicesList}>
            <ServiceCard 
                title="Diagnoza i terapia zaburzeń mowy i komunikacji"
                description="Rozpoznanie trudności i ich przyczyn. Systematyczna praca i wsparcie dostosowane do przyczyny, rodzaju i stopnia zaburzeń."
                icon={speechBubbleIcon}
            />
                <ServiceCard 
                title="Opieka przed i po zabiegu podcięcia wędzidełka języka (frenotomii, frenuloplastyce)"
                description="Ankyloglosja – zbyt krótkie lub nieprawidłowo zbudowane wędzidełko ogranicza ruchy
języka i utrudnia mówienie, jedzenie czy połykanie - pielęgnacja przed i po zabiegu odgrywa
bardzo ważną rolę."
                icon={surgeryToolsIcon}
            />
                <ServiceCard 
                title="Terapia ręki"
                description="Ćwiczenia, prowadzące do stabilizacji centralnej i swobodnej pracy rąk, aby były one w
stanie realizować swoje funkcje w możliwie najlepszy sposób."
                icon={dyslexiaIcon}
            />
        </div>
        </div>
        </section>
        <section className={styles.about}>
          <div className={styles.aboutContent}>
            <h2>O MNIE</h2>
            <p> W mojej pracy kieruję się przede wszystkim indywidualnym podejściem do pacjenta, empatią
i zrozumieniem. Jako terapeutka mowy potrafię dostrzegać unikalne potrzeby każdej osoby.
Moje wieloletnie doświadczenie umożliwia elastyczne dostosowywanie metod
terapeutycznych do specyficznych potrzeb pacjenta.</p>
          </div>
          <div className={styles.aboutImageWrapper}>
            <img src={aboutImage} alt="" />
          </div>
        </section>
        <section className={styles.photoGallery}>
          <h2>GALERIA</h2>
          <div className={styles.galleryImages}>
            <Gallery images={galleryImages} />
            </div>
            </section>'
    </main>
  );
}